import { axios } from "../axios";

export const dataTest = async () => {
  try {
    const { data } = await axios.get(`/data`);
    return await Promise.resolve(data);
  } catch (err) {
    return await Promise.reject(err);
  }
};
